
        import Symbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-scene_3d",
  "use": "icon-rescls-scene_3d-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-rescls-scene_3d\"><path fill=\"#9bcbdd\" d=\"M21.999 17.61 22 15.163l-5.142.003-4.722-2.062a.34.34 0 0 0-.272 0L7.132 15.17 2 15.174l.003 2.398h.01a.3.3 0 0 0 .178.328l8.993 3.93a2.04 2.04 0 0 0 1.63 0l8.994-3.93a.3.3 0 0 0 .184-.263h.005v-.019z\" /><path fill=\"#dce8f3\" d=\"m11.184 10.899-8.993 3.93a.307.307 0 0 0 0 .57l8.993 3.93a2.04 2.04 0 0 0 1.63 0l8.994-3.93a.307.307 0 0 0 0-.57l-8.992-3.93a2.05 2.05 0 0 0-1.632 0\" /><path fill=\"#009e56\" d=\"M12.977 2h-2.1l.028.704c-.883.66-1.472 1.733-1.472 3.006 0 2.487 1.625 3.642 2.677 6.078l-.714.49-.423 3.47 2.053-.898c.076 0 .152-.08.152-.239.608-4.663 3.444-5.723 3.444-8.903C16.42 3.696 14.799 2 12.977 2\" /><path fill=\"#00b066\" d=\"M10.923 2C8.999 2 7.377 3.701 7.377 5.968c0 3.515 2.836 4.536 3.444 9.526 0 .34.303.34.303 0 .608-4.99 3.444-6.124 3.444-9.526C14.365 3.815 12.745 2 10.923 2\" /><path fill=\"#fff\" d=\"M12.34 6.082c0 1.02-.709 1.701-1.52 1.701-.81 0-1.416-.794-1.416-1.7 0-1.02.708-1.588 1.418-1.588.81-.114 1.518.68 1.518 1.587\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-scene_3d"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-scene_3d";

        export default Icon;
    